import { Banner } from '@mm/components';
import { InstagramWelcomerIcon } from '@mm/icons/StarterIcons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import igIphoneStoryMentions from 'assets/iphone-ig-story-mentions.png';
import igIphoneStory from 'assets/iphone-ig-story.png';
import React from 'react';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { TooltipGuard } from '../../../../../../modules/permissions/RequiresPermissions';
import { BetaIgTitle } from '../ActivateIGBanner/ActivateIGBanner';
import './ActivateIGStoryMentionsBanner.pcss';

export const ActivateIGStoryMentionsBanner = () => {
  const { openInstagramConnectModal } = useModalActions();

  return (
    <Banner
      css={{ container: 'activate-ig-story-mentions-banner' }}
      title={
        <BetaIgTitle title="Automatically message users who mention your account on an Instagram Story." />
      }
      withArrow
      reverse
      button={
        <TooltipGuard>
          {isAllowed => (
            <PrimaryButton
              onClick={() => openInstagramConnectModal()} // Note: it is needed to be done this way due to types missmatch
              leftIcon={<InstagramWelcomerIcon color="#fff" />}
              color={ButtonColor.green}
              disabled={!isAllowed}
            >
              Connect Instagram
            </PrimaryButton>
          )}
        </TooltipGuard>
      }
    >
      <div className="activate-ig-story-mentions-banner__images-container">
        <img
          src={igIphoneStory}
          className="c-banner__iphone-icon activate-ig-story-mentions-banner__phone-icon"
        />
        <img
          src={igIphoneStoryMentions}
          className="c-banner__iphone-icon activate-ig-story-mentions-banner__phone-icon"
        />
      </div>
    </Banner>
  );
};
